import Util from "@/helper/Utility.js";

export default {
    inject: ["AccountStore"],
    computed: {
        isInitial: function () {
            return this.AccountStore.state.isInitial;
        },
        isLogin: function () {
            return this.AccountStore.state.isLogin;
        },
        profile: function () {
            if (this.isLogin) {
                return this.AccountStore.state.profile;
            } else {
                return null;
            }
        },
    },
    created: function () {
        this.AccountStore.methods.loginStatus().subscribe(() => {
            if (Util.isFunction(this.onAccountInit)) {
                this.onAccountInit();
            }
        });
    },
}
